import { useEffect, useState } from "react";
import AddEditSMRAgreementForm from "../forms/add-edit-smr-agreement-form";
import SmrAgreementHistory from "./smr-agreement-history";
import { useStore } from "../../../contexts/store-provider";
import { observer } from "mobx-react";
import DeletePopupHOC from "../../../shared-components/popup/delete/delete-popup-hoc";
import DeletePopup from "../../../shared-components/popup/delete/delete-popup";
import toast from "react-hot-toast";
import { formatMessage } from "../../../translations/format-message";
import { SMRTabEnum } from "../../../constants/enums/smr-tab-enum";
import { IAddAgreementRecord } from "../../../models/response/ISMRResponse";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import { isOperationPermittedRoleBase } from "../../../helpers/action-permission-helper";
import { ModuleType } from "../../../constants/enums/module-type-enum";
import { ActionType } from "../../../constants/enums/action-type-enum";
import Nodata from "../../../shared-components/no-data-svg/no-data-svg";
import { FormattedMessage } from "react-intl";
import NoAgreement from "../../../shared-components/no-data-svg/no-agreement-svg";
import { getUserTypeFromLocalStorage } from "../../../helpers/localstorage-helper";
import userTypeEnum from "../../../constants/enums/user-type-enum";

interface IProps {
  customerId: number;
  storeId: number;
  showDeletePopup: boolean;
  deletePopupToggleHandler: () => void;
  scrollToCard: (id: number) => void;
}

const AgreementRecord = (props: IProps) => {
  const { customerId, storeId, showDeletePopup, deletePopupToggleHandler } =
    props;
  const { smrStore } = useStore();
  const {
    GetSalesAgreementRecordStateBySMRIdService,
    salesAgreementRecordState,
    GetSaleRecordAgreementHistoryListService,
    salesAgreementRecordHistoryListState,
    resetDseleteSaleAgreementRecordState,
    selectedBookingId,
    activeTab,
    AddSalesAgreementRecordService,
    addUpdateSaleAgreementRecordState,
    resetAddUpdateSalesAgreementRecordState,
    DeleteSalesAgreementRecordService,
    deleteSaleAgreementRecordState,
    allBookingList,
    VerifyIsNavigationPasswordNotSetForAgreementService,
    isNavigationPasswordNotSetForAgreementState,
  } = smrStore;
  const [selectedId, setSelectedId] = useState<number>(0);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const addSalesAgreementRecordHadler = (values: IAddAgreementRecord) => {
    AddSalesAgreementRecordService({ ...values }, customerId);
  };

  useEffect(() => {
    if (
      activeTab === SMRTabEnum.Agreement &&
      selectedBookingId > 0 &&
      allBookingList.length > 0
    ) {
      if(getUserTypeFromLocalStorage() === userTypeEnum[userTypeEnum.Store])
        VerifyIsNavigationPasswordNotSetForAgreementService(storeId, "");
      GetSalesAgreementRecordStateBySMRIdService(selectedBookingId);
    }
  }, [selectedBookingId, activeTab]);

  useEffect(() => {
    if (isOpen && activeTab === SMRTabEnum.Agreement) {
      GetSaleRecordAgreementHistoryListService(customerId, storeId);
    }
  }, [isOpen, activeTab]);

  const deleteHandler = () => {
    DeleteSalesAgreementRecordService(selectedId);
  };

  useEffect(() => {
    if (deleteSaleAgreementRecordState.success) {
      if (isOpen) GetSaleRecordAgreementHistoryListService(customerId, storeId);
      toast.success(formatMessage("deleted_success"));
      resetDseleteSaleAgreementRecordState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteSaleAgreementRecordState.success]);

  useEffect(() => {
    if (addUpdateSaleAgreementRecordState.success) {
      if (isOpen) GetSaleRecordAgreementHistoryListService(customerId, storeId);
      toast.success(formatMessage("added_success"));
      resetAddUpdateSalesAgreementRecordState();
      GetSalesAgreementRecordStateBySMRIdService(selectedBookingId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateSaleAgreementRecordState.success]);

  return (
    <>
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_sales_record"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_sales_record_confirm"
          isLoading={deleteSaleAgreementRecordState.success}
        />
      )}
      {(salesAgreementRecordState.inProgress ||
        deleteSaleAgreementRecordState.inProgress ||
        salesAgreementRecordState.inProgress ||
        salesAgreementRecordHistoryListState.inProgress ||
        isNavigationPasswordNotSetForAgreementState.inProgress ||
        addUpdateSaleAgreementRecordState.inProgress) && (
        <FormLoader
          loading={
            salesAgreementRecordState.inProgress ||
            deleteSaleAgreementRecordState.inProgress ||
            salesAgreementRecordState.inProgress ||
            salesAgreementRecordHistoryListState.inProgress ||
            isNavigationPasswordNotSetForAgreementState.inProgress ||
            addUpdateSaleAgreementRecordState.inProgress
          }
        />
      )}
      {allBookingList.length > 0 ? (
        <div className="p-3 agreement-wrapper">
          <div className="row">
            <div
              className={`current-agreement col-12 ${
                isOpen ? "col-md-9" : "col-md-12"
              }`}
            >
              <AddEditSMRAgreementForm
                isOpen={isOpen}
                toggleHistory={toggleSidebar}
                viewOnly={
                  !isOperationPermittedRoleBase(
                    ModuleType.SalesMedicalRecord,
                    ActionType.Add
                  )
                }
                submitHandler={addSalesAgreementRecordHadler}
              />
            </div>
            <div
              className={`current-agreement col-12 ${
                isOpen ? "col-md-3" : "d-none"
              }`}
            >
              <SmrAgreementHistory scrollToCard={props.scrollToCard} />
            </div>
          </div>
        </div>
      ) : (
        <div className="text-danger text-center no-data">
          <NoAgreement />
          <p className="text-danger">
            <strong>
              <FormattedMessage id="no_data_available" />
            </strong>
          </p>
        </div>
      )}
    </>
  );
};

export default DeletePopupHOC(observer(AgreementRecord));
